import { CSSProperties } from "react";
import { FixedColState } from "src/components/ReactiveTable/components/ReactiveTable/componentProps";
import { RtCtrlColumnsView } from "src/components/ReactiveTable/ctrl";
import { RtColumnDef } from "src/components/ReactiveTable/RtColumn";
import { AbstractRow } from "src/components/ReactiveTable/RtTypes";

/**
 * Вычисляет стили для ячейки таблицы
 */
export const getCellStyle = <TRow extends AbstractRow>(
  column: RtColumnDef,
  store: RtCtrlColumnsView<TRow>,
  fixedInfo?: FixedColState,
): CSSProperties => {
  const isFixed = fixedInfo?.side === "left" || fixedInfo?.side === "right";
  return {
    width: store.getColumnWidth(column),
    minWidth: column.minWidth,
    textAlign: column.align,
    ...(isFixed ? { [fixedInfo.side]: `${fixedInfo.pos}px` } : {}),
  };
};
